import React from 'react';
import * as Styled from './loader.styles';

export interface LoaderProps {
  size?: number;
  className?: string;
}

const Loader: React.FC<LoaderProps> = ({size = 40, className}) => {
  return <Styled.Loader size={size} className={className} />;
};

export interface PageLoaderProps extends LoaderProps {}

/** Full-screen centered spinner for bootstrap / auth / route Suspense. */
const PageLoader: React.FC<PageLoaderProps> = ({size = 40, className}) => {
  return (
    <Styled.PageLoaderRoot className={className} role="status" aria-busy="true" aria-label="Loading">
      <Styled.Loader size={size} />
    </Styled.PageLoaderRoot>
  );
};

export {PageLoader};
export default Loader;
